import { createActionThunk } from 'redux-thunk-actions';
import { handleActions } from 'redux-actions';

export const showPopup = createActionThunk('SHOW_POPUP', (popup: any) => {
  return popup
})

export const closePopup = createActionThunk('CLOSE_POPUP', () => null)

const initialState = {
  popup: null,
  blurred: false,
};

export const popupReducer = handleActions(
  {
    'SHOW_POPUP_SUCCEEDED': (state: any, action: any) => ({
      ...state,
      popup: action.payload,
      blurred: true,
    }),
    'CLOSE_POPUP_SUCCEEDED': (state: any, action: any) => ({
      ...state,
      popup: null,
      blurred: false,
    }),
  },
  initialState
);
